import { Box, Button, ButtonGroup, InputLabel, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BetBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: theme.spacing(2, 0),
  borderRadius: '0px 0px 8px 8px',
  // background: theme.palette.bg.secondary,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(1),
  },
}));

export const BetBoxSetion = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));
export const BetBoxContent = styled('section')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',

  position: 'relative',
  '.MuiInputBase-root': {
    paddingLeft: theme.spacing(3),
  },
  '& svg': {
    position: 'absolute',
    zIndex: 1,
    left: '8px',
  },
  '.MuiTypography-root': {
    position: 'absolute',
    zIndex: 1,
    right: '8px',
    opacity: '0.5',
  },
  [theme.breakpoints.down('md')]: {},
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  border: '1px solid #848E9C',
  color: theme.palette.text.desc,
  background: theme.palette.bg.main,
  padding: theme.spacing(0.5, 1),
  fontSize: '12px',
  lineHeight: '20px',
  height: '30px',
  flex: 1,
  minWidth: 'auto',
  '&:hover': {
    filter: 'brightness(0.8)',
    border: '1px solid #8A8A98',
    color: theme.palette.text.desc,
    background: theme.palette.bg.main,
  },
  // color: theme.palette.text.secondary,
  // '&.Mui-disabled.MuiButton-containedSuccess': {
  //   opacity: 0.5,
  //   background: '#01A43B',
  //   color: theme.palette.primary.contrastText,
  // },
}));

export const StyledBetBtn = styled(Button)(({ theme }) => ({
  color: theme.palette.bg.main,
  maxHeight: '76px',
  '&.Mui-disabled': {
    pointerEvents: 'all',
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  '& .MuiTypography-h5': {
    fontSize: '18px',
    fontWeight: 500,
  },
  '& .MuiTypography-h6': {
    fontSize: '14px',
    fontWeight: 500,
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  ...theme.typography.body2,

  color: '#EEEEFB',
  paddingBottom: theme.spacing(1),
  height: '32px',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  alignSelf: 'flex-start',
  // height: '40px',
  background: theme.palette.bg.secondary,
  border: theme.palette.border.normal,
  width: '100%',
  fontWeight: 700,
  borderRadius: theme.shape.borderRadius,
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 2),
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const StyledButtonGroup = styled(Box)(({ theme }) => ({
  // background: theme.palette.grey['700'],
  display: 'flex',
  width: '100%',
  gap: '4px',
  // '& .MuiButtonBase-root ': {
  //   background: theme.palette.grey['800'],
  // },
}));

export const StyledSwitchSection = styled('div')({
  // display: 'flex',
  // flexDirection: 'column',
  // justifyContent: 'flex-start',
  width: '270px',
});

export const StyledAutoBetSwitch = styled(Box)(({ theme }) => ({
  lineHeight: '32px',
  width: '100%',
  height: '32px',
  marginBottom: theme.spacing(1),
  '&>span:first-of-type': {
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'left',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    transform: 'translateY(0)',
  },
}));

export const StopAtSection = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    gap: '4px',
    // '& .MuiFormControl-root': {
    //   borderTopRightRadius: 0,
    //   borderBottomRightRadius: 0,
    // },
    // '& .MuiButtonGroup-grouped:not(:last-of-type)': {
    //   borderTopLeftRadius: 0,
    //   borderBottomLeftRadius: 0,
    // },
  },
}));

export const DebugBoxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  zIndex: 999999,
  top: 80,
  width: '400px',
  height: '400px',
  padding: theme.spacing(1),
  background: '#000',
  borderRadius: '8px',
  color: '#fff',
  right: 0,
  [theme.breakpoints.down('md')]: {},
}));
